import {
  axiosInstance,
  getErrorStatus
} from './axiosInstance';

export const getFinancialDetails = async () => {
  let response;
  const businessId = sessionStorage.getItem('businessId');

  try {
    response = await axiosInstance.get(`/business-financials/${businessId}`);

  } catch (err) {

    response = {
      data: {
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response.data;
};

export const setFinancialDetails = async (data) => {
  let response;
  const businessId = sessionStorage.getItem('businessId');

  try {
    response = await axiosInstance.patch(`/business-financials/${businessId}`, data);
  } catch (err) {

    response = {
      data: {
        ...data,
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response;
};

export const createFinancialDetails = async (data) => {
  let response;
  const businessId = sessionStorage.getItem('businessId');
  try {
    response = await axiosInstance.post(`/business-financials/${businessId}`, data);
  } catch (err) {

    response = {
      data: {
        ...data,
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response;
};